import React, { useEffect, useState } from 'react';

import { WarningOutlined } from '@ant-design/icons';
import { Grid } from '@lp/ds-next';
import { Tag, Typography } from 'antd';
import { useParams } from 'react-router-dom';

import ShipmentDetailsContent from '../components/ShipmentDetailsContent';
import InspectedIcon from '@/components/icons/InspectedIcon';
import PageTitle from '@/components/layout/PageTitle';
import { useGetLitigation } from '@/features/gdpr/litigation/api/getLitigation';
import { LitigationTag } from '@/features/gdpr/litigation/components/LitigationTag';
import { useGetListInspection } from '@/features/securityCheck/api/getInspectionList';
import useError from '@/hooks/useError';

const { Text } = Typography;

const ShipmentDetailsView = () => {
  const { id } = useParams<{ id: string }>();
  const addError = useError();

  const { data, error } = useGetLitigation({
    shipmentId: id!,
  });

  const { data: inspectionData } = useGetListInspection({
    shipmentIds: id ? [id] : [],
    enabled: !!id,
  });

  const [isRTS, setIsRTS] = useState(false);

  useEffect(() => {
    if (error) {
      addError(error);
    }
  }, [data, error, addError]);

  const isFlaggedOrSolved =
    data?.status === 'FLAGGED' || data?.status === 'SOLVED';

  const isInspected =
    inspectionData?.[0]?.status === 'USED' ||
    inspectionData?.[0]?.status === 'EXPIRED';

  const isInspectionValid =
    inspectionData?.[0] &&
    isInspected &&
    (inspectionData[0].startedAt || inspectionData[0].endedAt);

  return (
    <Grid container justifyContent="center" spacing={3}>
      <Grid item mobile={11}>
        <PageTitle
          title="SHIPMENT DETAILS"
          tag={
            <>
              {isInspectionValid && (
                <Tag
                  color="#91D5FF"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px',
                  }}
                  icon={<InspectedIcon color="#1890FF" />}
                >
                  <Text
                    style={{
                      color: '#1890FF',
                      fontWeight: '500',
                      fontSize: '0.75rem',
                      textTransform: 'initial',
                      letterSpacing: '0',
                    }}
                  >
                    Inspected
                  </Text>
                </Tag>
              )}
              {isRTS && (
                <Tag color="#FFF4F0">
                  <WarningOutlined
                    style={{ color: '#9A4F25', fontSize: '1rem' }}
                  />
                  <Text
                    style={{
                      color: '#9A4F25',
                      fontWeight: '500',
                      fontSize: '0.75rem',
                      textTransform: 'initial',
                      letterSpacing: '0',
                    }}
                  >
                    Return to sender
                  </Text>
                </Tag>
              )}
              {isFlaggedOrSolved && (
                <LitigationTag litigationState={data?.status} />
              )}
            </>
          }
        />
      </Grid>
      <Grid item mobile={11}>
        <ShipmentDetailsContent
          setIsRTS={setIsRTS}
          litigationState={data?.status}
          litigationId={data?.id}
        />
      </Grid>
    </Grid>
  );
};
export default ShipmentDetailsView;
